import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CountdownService {
    pauseCountdown$!: Observable<boolean>;
    restartCountdown$!: Observable<void>;

    private readonly pausedSubject = new BehaviorSubject(false);
    private readonly restartSubject = new Subject<void>();

    constructor() {
        this.pauseCountdown$ = this.pausedSubject.asObservable();
        this.restartCountdown$ = this.restartSubject.asObservable();
    }

    pause(): void {
        this.pausedSubject.next(true);
    }

    resume(): void {
        this.pausedSubject.next(false);
    }

    restart(): void {
        this.pausedSubject.next(false);
        this.restartSubject.next();
    }
}
